import SmartSkinScan from 'components/SmartSkinScan/SmartSkinScan';
import { withSmartSkinScanProps } from 'viewModel/smartSkinScan/withSmartSkinScanProps';

export default withSmartSkinScanProps(SmartSkinScan);
